import { c as _c } from "react/compiler-runtime";
import { Box, Typography } from '@mui/material';
import { Badge } from './Badge';
import { ProductCardTypography } from './ProductCardTypography';
type Props = {
  awards: {
    default: string;
    additional?: string;
  };
};
export function ReviewBanner(t0) {
  const $ = _c(11);
  const {
    awards
  } = t0;
  let t1;
  if ($[0] !== awards.additional || $[1] !== awards.default) {
    t1 = awards.additional ? [awards.default, awards.additional] : [awards.default];
    $[0] = awards.additional;
    $[1] = awards.default;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const awardsList = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      display: "flex",
      backgroundColor: "lime.lightest",
      borderTopLeftRadius: "8px",
      borderTopRightRadius: "8px",
      borderLeft: "1px solid",
      borderRight: "1px solid",
      borderColor: "neutral.lighter",
      overflow: "hidden"
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Box><Badge width="51.2" height="64" style={{
        flexShrink: 0
      }} /></Box>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      flex: 1
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      paddingX: 3,
      paddingY: 1,
      backgroundColor: "primary.main"
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Box sx={t5}><Typography sx={{
        textTransform: "uppercase",
        letterSpacing: "0.65px",
        fontWeight: 500,
        color: "lime.tintLP2",
        lineHeight: "150%",
        fontSize: 13
      }}>Nerdwallet best-of awards</Typography></Box>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      display: "flex",
      flexDirection: "column",
      paddingX: 3,
      paddingY: 2,
      gap: 2
    };
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== awardsList) {
    t8 = <Box sx={t2}>{t3}<Box sx={t4}>{t6}<Box sx={t7}>{awardsList.map(_temp)}</Box></Box></Box>;
    $[9] = awardsList;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  return t8;
}
function _temp(award) {
  return <ProductCardTypography key={award}>2026 {award}</ProductCardTypography>;
}